<!--
 * @Description: 商品销售额排行（带俪丰/联农切换，自动滚动）
 * @Author: xiawenlong
 * @Date: 2024-11-25 14:22:25
 * @LastEditors: xiawenlong
-->
<template>
  <div class="product-rank">
    <div class="header">
      <div class="title">
        <img src="@/img/datav-tc/title_icon.png" alt="" />
        <span>商品销售额排行</span>
      </div>
      <div class="tab">
        <div :class="['tab-item', { active: type == 'lifeng' }]" @click="typeChange('lifeng')">
          俪丰
        </div>
        <div :class="['tab-item', { active: type == 'liannong' }]" @click="typeChange('liannong')">
          联农
        </div>
      </div>
    </div>
    <div class="rank-header">
      <span class="rank-title">排名</span>
      <span class="name-title">商品名称</span>
      <span class="sales-title">销售额</span>
    </div>
    <vue-seamless-scroll :data="data" :class-option="scrollOption" class="rank-list">
      <div v-for="(item, index) in data" :key="index" class="rank-item">
        <div
          class="rank-num"
          :class="{ 'top-1': index === 0, 'top-2': index === 1, 'top-3': index === 2 }"
        >
          <span>{{ index + 1 }}</span>
        </div>
        <div class="product-name">{{ item.name }}</div>
        <div class="sales-num">{{ item.value }}万元</div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { getProductAmountRank, getGroupStoreList } from '@/api/dashboard-tc'

export default {
  data() {
    return {
      type: 'lifeng',
      scrollOption: {
        step: 0.5,
        limitMoveNum: 5,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000,
      },
      data: [],
      appidMap: {},
      timer: null,
    }
  },
  mounted() {
    this.initAppid()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async initAppid() {
      try {
        const res = await getGroupStoreList()
        if (res.code === 0 && res.data) {
          res.data.forEach(item => {
            if (item.storeName.includes('俪丰')) {
              this.appidMap.lifeng = item.appid
            } else if (item.storeName.includes('联农')) {
              this.appidMap.liannong = item.appid
            }
          })
          this.fetchData()
          this.timer = setInterval(() => {
            this.fetchData()
          }, process.env.VUE_APP_LTIME_TC)
        }
      } catch (error) {
        console.error('获取集团列表失败:', error)
      }
    },
    async fetchData() {
      try {
        const appid = this.type === 'lifeng' ? this.appidMap.lifeng : this.appidMap.liannong
        if (!appid) {
          console.warn('appid未获取到')
          return
        }
        const res = await getProductAmountRank(appid)
        if (res.code === 0) {
          this.data = res.data
        }
      } catch (error) {
        console.error('获取销售额排行失败:', error)
      }
    },
    typeChange(type) {
      this.type = type
      this.fetchData()
    },
  },
}
</script>

<style lang="scss" scoped>
.product-rank {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 25px 25px;
  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    flex-shrink: 0;

    .title {
      font-size: 24px;
      color: #ecf8ff;
      display: flex;
      align-items: center;

      img {
        margin-right: 3px;
      }
    }

    .tab {
      display: flex;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 20px;
      border: 1px solid rgba(0, 192, 254, 0.3);
      padding: 3px;
      position: relative;
      overflow: hidden;
      margin-top: 10px;

      &::before {
        content: '';
        position: absolute;
        inset: -2px;
        background: linear-gradient(90deg, #00c0fe, #126dff, #00c0fe);
        border-radius: 22px;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover::before {
        opacity: 0.3;
      }

      .tab-item {
        padding: 0 16px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 13px;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0, 192, 254, 0.2), rgba(18, 109, 255, 0.2));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover {
          color: #66ffff;

          &::before {
            opacity: 1;
          }
        }

        &.active {
          background: linear-gradient(90deg, #00c0fe 0%, #126dff 100%);
          color: #fff;
          box-shadow: 0 0 15px rgba(0, 192, 254, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2);
          font-weight: 600;

          &::before {
            display: none;
          }
        }
      }
    }
  }

  .rank-header {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid rgba(0, 192, 254, 0.3);
    margin-bottom: 8px;
    flex-shrink: 0;

    .rank-title {
      width: 50px;
      font-size: 18px;
      color: #899dbf;
      text-align: center;
    }

    .name-title {
      flex: 1;
      font-size: 18px;
      color: #899dbf;
      padding-left: 15px;
    }

    .sales-title {
      width: 80px;
      font-size: 18px;
      color: #899dbf;
      text-align: right;
    }
  }

  .rank-list {
    flex: 1;
    overflow: hidden;

    .rank-item {
      display: flex;
      align-items: center;
      padding: 10px 12px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      margin-bottom: 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;

      &:last-child {
        border-bottom: none;
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 3px;
        background: linear-gradient(180deg, #00c0fe 0%, #126dff 100%);
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 0 6px 8px;
        border-color: transparent transparent transparent rgba(102, 255, 255, 0.6);
        opacity: 0;
        transition: all 0.3s ease;
      }

      &:hover {
        background: linear-gradient(
          90deg,
          rgba(0, 192, 254, 0.15) 0%,
          rgba(0, 192, 254, 0.05) 100%
        );
        transform: translateX(4px);

        &::before {
          opacity: 1;
        }

        .sales-num {
          color: #fff;
          text-shadow: 0 0 10px rgba(102, 255, 255, 0.8);
        }
      }

      .rank-num {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 14px;
        color: #ffffff;
        margin-right: 15px;
        background: rgba(0, 192, 254, 0.15);
        border: 1px solid rgba(0, 192, 254, 0.4);
        flex-shrink: 0;
        font-weight: 600;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          animation: shimmer 3s infinite;
        }

        @keyframes shimmer {
          0% {
            left: -100%;
          }
          50%,
          100% {
            left: 100%;
          }
        }

        span {
          display: block;
        }

        &.top-1 {
          background: linear-gradient(135deg, #ff006e 0%, #8338ec 100%);
          border: none;
          font-weight: bold;
          box-shadow: 0 0 20px rgba(255, 0, 110, 0.6), 0 0 40px rgba(255, 0, 110, 0.3),
            inset 0 0 10px rgba(255, 255, 255, 0.3);
          border-radius: 50% 50% 50% 4px;
          transform: rotate(-45deg);
          animation: neon-glow-1 2s ease-in-out infinite alternate;

          span {
            transform: rotate(45deg);
          }
        }

        &.top-2 {
          background: linear-gradient(135deg, #3a86ff 0%, #00f5ff 100%);
          border: none;
          font-weight: bold;
          box-shadow: 0 0 15px rgba(58, 134, 255, 0.5), 0 0 30px rgba(58, 134, 255, 0.3),
            inset 0 0 8px rgba(255, 255, 255, 0.25);
          border-radius: 50% 50% 4px 50%;
          transform: rotate(-45deg);
          animation: neon-glow-2 2s ease-in-out infinite alternate;

          span {
            transform: rotate(45deg);
          }
        }

        &.top-3 {
          background: linear-gradient(135deg, #ffbe0b 0%, #fb5607 100%);
          border: none;
          font-weight: bold;
          box-shadow: 0 0 12px rgba(255, 190, 11, 0.5), 0 0 25px rgba(255, 190, 11, 0.25),
            inset 0 0 6px rgba(255, 255, 255, 0.25);
          border-radius: 4px 50% 50% 50%;
          transform: rotate(-45deg);
          animation: neon-glow-3 2s ease-in-out infinite alternate;

          span {
            transform: rotate(45deg);
          }
        }

        @keyframes neon-glow-1 {
          from {
            box-shadow: 0 0 20px rgba(255, 0, 110, 0.6), 0 0 40px rgba(255, 0, 110, 0.3),
              inset 0 0 10px rgba(255, 255, 255, 0.3);
          }
          to {
            box-shadow: 0 0 25px rgba(255, 0, 110, 0.8), 0 0 50px rgba(255, 0, 110, 0.4),
              0 0 70px rgba(255, 0, 110, 0.2), inset 0 0 12px rgba(255, 255, 255, 0.4);
          }
        }

        @keyframes neon-glow-2 {
          from {
            box-shadow: 0 0 15px rgba(58, 134, 255, 0.5), 0 0 30px rgba(58, 134, 255, 0.3),
              inset 0 0 8px rgba(255, 255, 255, 0.25);
          }
          to {
            box-shadow: 0 0 20px rgba(58, 134, 255, 0.7), 0 0 40px rgba(58, 134, 255, 0.4),
              0 0 60px rgba(58, 134, 255, 0.2), inset 0 0 10px rgba(255, 255, 255, 0.35);
          }
        }

        @keyframes neon-glow-3 {
          from {
            box-shadow: 0 0 12px rgba(255, 190, 11, 0.5), 0 0 25px rgba(255, 190, 11, 0.25),
              inset 0 0 6px rgba(255, 255, 255, 0.25);
          }
          to {
            box-shadow: 0 0 18px rgba(255, 190, 11, 0.7), 0 0 35px rgba(255, 190, 11, 0.35),
              0 0 50px rgba(255, 190, 11, 0.2), inset 0 0 8px rgba(255, 255, 255, 0.35);
          }
        }
      }

      .product-name {
        flex: 1;
        font-size: 18px;
        color: #dae3f6;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 15px;
        transition: color 0.3s ease;
      }

      .sales-num {
        font-size: 18px;
        color: #fedb65;
        font-weight: bold;
        min-width: 80px;
        text-align: right;
        flex-shrink: 0;
        transition: all 0.3s ease;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -2px;
          right: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent, #fedb65);
          transition: width 0.3s ease;
        }
      }

      &:hover .sales-num::after {
        width: 100%;
      }
    }
  }
}
</style>
